exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".touch-action-manipulation[data-v-0a633912]{touch-action:manipulation}.fade[data-v-0a633912]{animation-name:oz-overlay-fade-0a633912;animation-duration:0.2s;will-change:opacity}@keyframes oz-overlay-fade-0a633912{0%{opacity:0}100%{opacity:1}}\n", ""]);

